import { Badge, Button, Card, Col, ListGroup, Row } from 'react-bootstrap';
import { formatDataHora } from '../../utils/dateUtils';
import {
  FormattedField,
  FormattedIntegration,
} from '../../utils/formatters/integracaoExternaFormatter';
import IntegracaoExternaRawJson from './IntegracaoExternaRawJson';

interface IntegracaoExternaDetailProps {
  integration: FormattedIntegration;
  onBack: () => void;
}

function renderField(field: FormattedField, index: number) {
  return (
    <div key={index} className="d-flex justify-content-between py-1 border-bottom">
      <span className="text-muted small">{field.label}</span>
      {field.variant ? (
        <Badge bg={field.variant}>{String(field.value)}</Badge>
      ) : (
        <span className="text-end">{String(field.value)}</span>
      )}
    </div>
  );
}

export default function IntegracaoExternaDetail({ integration, onBack }: IntegracaoExternaDetailProps) {
  const listSections = integration.sections.filter((s) => s.title.startsWith('Registro ') || s.title.startsWith('Processo '));
  const cardSections = integration.sections.filter((s) => !listSections.includes(s));

  return (
    <div>
      <div className="d-flex justify-content-between align-items-start mb-3">
        <div>
          <h5>
            <Badge bg="secondary" className="me-2">{integration.tipoLabel}</Badge>
            {integration.status && (
              <Badge bg={integration.status.variant}>{integration.status.label}</Badge>
            )}
          </h5>
          <p className="mb-0 text-muted">{formatDataHora(integration.dataHora)}</p>
        </div>
        <Button variant="secondary" size="sm" onClick={onBack}>
          Voltar à lista
        </Button>
      </div>

      {cardSections.length === 0 && listSections.length === 0 && (
        <p className="text-muted">Nenhuma informação formatada disponível para este registro.</p>
      )}

      <Row>
        {cardSections.map((section, idx) => (
          <Col md={6} key={idx} className="mb-3">
            <Card>
              <Card.Header className="fw-semibold">{section.title}</Card.Header>
              <Card.Body>{section.fields.map(renderField)}</Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {listSections.map((section, idx) => (
        <Card key={idx} className="mb-3">
          <Card.Header className="fw-semibold">{section.title}</Card.Header>
          <ListGroup variant="flush">
            {section.fields.map((field, fIdx) => (
              <ListGroup.Item key={fIdx} className="d-flex justify-content-between">
                <span className="text-muted small">{field.label}</span>
                {field.variant ? (
                  <Badge bg={field.variant}>{String(field.value)}</Badge>
                ) : (
                  <span>{String(field.value)}</span>
                )}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </Card>
      ))}

      <IntegracaoExternaRawJson
        request={integration.rawRequest}
        response={integration.rawResponse}
      />
    </div>
  );
}
